// components/WriteCommentModal.jsx

import React from "react";
import { Modal } from "react-bootstrap";
import "./WriteCommentModal.css";
import gauge_easy from "../../assets/images/gauge_easy.png";
import gauge_ok from "../../assets/images/gauge_ok.png";
import gauge_hard from "../../assets/images/gauge_hard.png";

const WriteCommentModal = ({
  isOpen,
  onClose,
  onSubmit,
  comment,
  setComment,
  difficulty,
  setDifficulty,
  langString
}) => {
  const difficulties = [
    { label: "Too Easy", icon: gauge_easy },
    { label: "Good", icon: gauge_ok },
    { label: "Too Hard", icon: gauge_hard },
  ];


  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      className="yesterday-modal write-comment-modal"
    >
      <div className="modal-content write-comment-modal-content">
        <span
          onClick={onClose}
          className="close-button-write-comment"
        >
          &times;
        </span>

        <div className="yesterdayAnswer-body">
          <h2 className="yestAnswer-title">{langString === "nl" ? "Schrijf je reactie:" : "Write your comment:"}</h2>

          <textarea
            className="write-comment-textarea"
            // placeholder="Type your comment here..."
            value={comment}
            onChange={(e) => setComment(e.target.value)}
             style={{
              fontFamily: "Union",
              fontSize: "1.5rem",
              color: "#000000",
              }}
          />

          <div className="difficulty-section">
            <p style={{ fontSize: "1.5rem", marginBottom: "8px",fontFamily: "Union",fontWeight:"normal" }}>
              {langString === "nl" ? "Deze challenge was:" : "This challenge was:"}
            </p>
            <div className="difficulty-icons">
              {difficulties.map((d) => (
                <div
                  key={d.label}
                  className={`difficulty-item ${
                    difficulty === d.label ? "selected" : ""
                  }`}
                  onClick={() => setDifficulty(d.label)}
                   style={{
                      border: difficulty === d.label ? "2px solid black" : "2px solid transparent",
                      borderRadius: "8px",
                      padding: "8px",
                      cursor: "pointer",
                      transition: "border 0.2s ease"
                    }}
                >
                  <img src={d.icon} alt={d.label} width="65" height="65" />
                  <p>{d.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="write-comment-buttons">
            <button className="cancel-button" onClick={onClose}>
              CANCEL
            </button>
            <button
              className={`send-button ${
                comment.trim() && difficulty ? "" : "disabled"
              }`}
              onClick={onSubmit}
              disabled={!comment.trim() || !difficulty}
            >
              {langString === "nl" ? "Versturen" : "send"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default WriteCommentModal;
